module.exports = __webpack_public_path__ + "img/system-4.6c0f80c0.png";